module.exports = __webpack_public_path__ + "static/media/AB_ZW10_12.9e3907fd.jpg";